module.exports = __webpack_public_path__ + "static/media/for-sale-sign.92a0c901.svg";